import { defineStore } from "pinia";
import { ref } from "vue";

/**
 * Open/closed state for the domain-object quick-view/quick-edit panel
 * (DomainObjectDrawer.vue), opened by clicking a node on the entities canvas.
 *
 * Deliberately holds only the id, not the entity: the panel resolves it
 * against the canvas's already-loaded entities list.
 */
export const useDomainObjectDrawerStore = defineStore(
    "domainObjectDrawer",
    () => {
        const drawerOpen = ref(false);
        const drawerEntityId = ref<string | undefined>(undefined);
        /** Whether the last close plays the panel's leave animation. */
        const drawerLeaveAnimated = ref(true);

        const openDrawer = (entityId: string) => {
            drawerEntityId.value = entityId;
            drawerOpen.value = true;
        };

        // Clears the entity id as well as the open flag. Keeping a stale id
        // around bought nothing (openDrawer always sets it) and actively hurt:
        // the panel resolves the id against a DOMAIN-SCOPED entities list, so a
        // retained id would still be pointing at an entity that had since left
        // the list, resolving to nothing.
        const closeDrawer = ({
            animate = true,
        }: { animate?: boolean } = {}) => {
            drawerLeaveAnimated.value = animate;
            drawerOpen.value = false;
            drawerEntityId.value = undefined;
        };

        return {
            drawerOpen,
            drawerEntityId,
            drawerLeaveAnimated,
            openDrawer,
            closeDrawer,
        };
    }
);
